import { Grid } from "@material-ui/core";
import { MasterButton, ModalExportList } from "App/Component/ui";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import React, { useContext, useState } from "react";
import {
  ModalSimpan,
  ModalBayar,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
  getExportExcel,
} from ".";
import { FormContext } from "../context/FormContext";
import ModalKwitansi from "./ModalKwitansi";
import ModalPDF from "./ModalPDF";
import ModalPotongan from "./ModalPotongan";

function ButtonAction({
  reset,
  setNewDataTabTagihan,
  setNewDataTabPembayaran,
  tagihanID,
  formData,
  setAllNewData,
}) {
  const [showModalSimpan, setShowModalSimpan] = useState(false);
  const [showModalKwitansi, setShowModalKwitansi] = useState(false);
  const [showModalPDF, setShowModalPDF] = useState(false);
  const [showModalPembayaran, setShowModalPembayaran] = useState(false);
  const [showModalPotongan, setShowModalPotongan] = useState(false);
  const { rowsSelect } = useContext(FormContext);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);
  const handleClickExcel = async () => {
    setLoadingPrint(true);
    const res = await getExportExcel(formData?.rekap_tagihan_id);
    if (res.state) {
      defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...");
    } else {
      defaultToastError(res.message);
    }
    setLoadingPrint(false);
  };
  // const subTotal = convertToValidPrice(formData?.total_harga_tagihan) - convertToValidPrice(formData?.total_diskon);
  // const sisa = subTotal - convertToValidPrice(formData?.total_dibayar);
  const sisa =
    formData?.total_dibayar > 0
      ? convertToValidPrice(formData?.sisa_harga_tagihan)
      : convertToValidPrice(formData?.total_bayar_tagihan) -
        convertToValidPrice(formData?.total_diskon);

  function countTotal(data) {
    if (data.length === 0) {
      const dataHasil = { sisa_tagihan: 0 };
      return dataHasil;
    } else if (data.length === 1) {
      const dataHasil = { sisa_tagihan: data[0].sisa_tagihan };
      return dataHasil;
    } else if (data.length > 1) {
      const dataHasil = data.reduce(function (previousValue, currentValue) {
        return {
          sisa_tagihan:
            parseFloat(convertToValidPrice(previousValue.sisa_tagihan)) +
            parseFloat(convertToValidPrice(currentValue.sisa_tagihan)),
        };
      });
      return dataHasil;
    }
  }
  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setNewDataTabTagihan={setAllNewData}
          setShowModal={() => setShowModalSimpan(false)}
        />
      )}

      {showModalPembayaran && (
        <ModalBayar
          nilai={
            rowsSelect.length === 0
              // ? formatRupiah(
              //     convertToValidPrice(formData?.total_bayar_tagihan) - convertToValidPrice(formData?.total_dibayar)
              //   )
              ? formatRupiah(convertToValidPrice(formData?.sisa_harga_tagihan))
              : formatRupiah(
                  convertToValidPrice(countTotal(rowsSelect).sisa_tagihan)
                )
          }
          setNewData={setAllNewData}
          setShowModal={() => setShowModalPembayaran(false)}
          id={formData?.rekap_tagihan_id}
          total={formData?.total_harga_tagihan}
          diskon={formData?.diskon}
          totalDiskon={convertToValidPrice(formData?.total_diskon)}
          bayarDiskon={convertToValidPrice(formData.total_bayar_diskon)}
          asuransi_id={formData?.asuransi_id}
          asuransi_nama={formData?.asuransi_nama}
          countTotal={countTotal}
        />
      )}

      {showModalPotongan && (
        <ModalPotongan
          setNewData={setAllNewData}
          setShowModal={() => setShowModalPotongan(false)}
        />
      )}

      {showModalKwitansi && (
        <ModalKwitansi
          setShowModal={() => setShowModalKwitansi(false)}
          penerima={formData.asuransi_nama}
          nilai={sisa}
          no_surat={formData.no_surat}
          id={formData?.rekap_tagihan_id}
          datas={formData}
        />
      )}

      {showModalPDF && (
        <ModalPDF
          setShowModal={() => setShowModalPDF(false)}
          id={formData.rekap_tagihan_id}
          datas={formData}
        />
      )}
      <div>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}>
            <MasterButton
              type='button'
              color={"danger"}
              name={"RESET"}
              onClick={() => reset()}
              size='md'
            />
            <MasterButton
              type='button'
              color={"green"}
              name={"Refresh Data Rekap"}
              onClick={() => setAllNewData()}
              size='md'
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}>
            {!isNull(tagihanID) && (
              <>
                <MasterButton
                  type='button'
                  color={"warning"}
                  name={"DAFTAR EXPORT"}
                  onClick={() => setShowModalExportList(!showModalExportList)}
                  size='md'
                />
                <MasterButton
                  type='button'
                  color={
                    loadingPrint
                      ? "secondary"
                      : !isNull(formData.status_proses) &&
                        formData.status_proses >=
                          STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? "warning"
                      : "secondary"
                  }
                  name={loadingPrint ? "Loading" : "EXCEL"}
                  onClick={() =>
                    loadingPrint
                      ? null
                      : !isNull(formData.status_proses) &&
                        formData.status_proses >=
                          STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? handleClickExcel()
                      : null
                  }
                  size='md'
                />

                <MasterButton
                  type='button'
                  color={
                    !isNull(formData.status_proses) &&
                    formData.status_proses >=
                      STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? "warning"
                      : "secondary"
                  }
                  name={"PDF"}
                  onClick={() =>
                    !isNull(formData.status_proses) &&
                    formData.status_proses >=
                      STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? setShowModalPDF(!showModalPDF)
                      : null
                  }
                  size='md'
                />

                <MasterButton
                  type='button'
                  color={
                    !isNull(formData.status_proses) &&
                    formData.status_proses >=
                      STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? "warning"
                      : "secondary"
                  }
                  name={"KWITANSI"}
                  onClick={() =>
                    !isNull(formData.status_proses) &&
                    formData.status_proses >=
                      STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? setShowModalKwitansi(!showModalKwitansi)
                      : null
                  }
                  size='md'
                />

                <MasterButton
                  onClick={() =>
                    formData.status_proses ===
                    STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                      ? setShowModalPotongan(!showModalPotongan)
                      : null
                  }
                  type='button'
                  color={
                    formData.status_proses ===
                    STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                      ? "green"
                      : "secondary"
                  }
                  name={"DISKON"}
                  size='md'
                />

                <MasterButton
                  onClick={() =>
                    formData.status_proses ===
                    STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? setShowModalPembayaran(!showModalPembayaran)
                      : null
                  }
                  type='button'
                  color={
                    formData.status_proses ===
                    STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                      ? "warning"
                      : "secondary"
                  }
                  name={"BAYAR"}
                  size='md'
                />
              </>
            )}
            <MasterButton
              onClick={() => setShowModalSimpan(!showModalSimpan)}
              type='submit'
              color={"green"}
              name={"SIMPAN"}
              size='md'
            />
          </div>
        </Grid>
      </div>
      {showModalExportList && (
        <ModalExportList
          title={`Daftar Export Excel List Rekap Tagihan (ID - ${formData?.rekap_tagihan_id})`}
          showModal={() => setShowModalExportList(false)}
          type={"Detailrekaptagihan"}
        />
      )}
    </>
  );
}

export default ButtonAction;
